import $ from 'jquery';
import gsap from 'gsap';
import Splitting from 'splitting';
import lightGallery from 'lightgallery';
import lgVideo from "lightgallery/plugins/video";

const galerie = {
	actual: null,
	timer: null,
	nbSlides: 0,
	nb: 0,
	elt: null,
	eltInf: null,
	nav: null,
	lg: null,
	anim: gsap.timeline(),

	init(actual, el, elInf, nav, useTimer = false) {
		this.actual = actual;
		this.elt = el;
		this.eltInf = elInf;
		this.nav = nav;

		this.applySplitting(actual);

		if (useTimer) {
			this.nb = actual;
			this.nbSlides = $(el).length;
			this.timer = setInterval(() => this.nextSlide(), 5000);
		}

		$(`${elInf}[data-nb="${actual}"]`).removeClass('_hide').addClass('_show');
		this.toggleShadow(el, actual);

		$(document).on('click', nav, (e) => {
			clearInterval(this.timer);
			const newId = $(e.currentTarget).data('nb');
			$(this.nav).removeClass('_activ');
			$(e.currentTarget).addClass('_activ');
			if (newId !== this.actual) {
				this.moveSlide(this.actual, newId);
			}
		});

		$(document).on('mouseover', '.slide_infos', () => clearInterval(this.timer));
		$(window).on('blur', () => clearInterval(this.timer));
	},

	nextSlide() {
		this.nb = this.nb < this.nbSlides ? this.nb + 1 : 1;
		this.moveSlide(this.actual, this.nb);
	},

	moveSlide(from, to) {
		this.toggleShadow(this.elt, to);

		$(this.nav).removeClass('_activ');
		$(`${this.nav}[data-nb="${to}"]`).addClass('_activ');

		this.anim.pause();
		this.anim = gsap.timeline();

		const height = $(this.elt).height();
		const $oldElt = $(`${this.elt}[data-nb="${from}"]`);
		const $newElt = $(`${this.elt}[data-nb="${to}"]`);
		const $oldInf = $(`${this.eltInf}[data-nb="${from}"]`);
		const $newInf = $(`${this.eltInf}[data-nb="${to}"]`);

		$oldElt.css('z-index', 5);
		$newElt.css('z-index', 10);
		$oldInf.removeClass('_show').addClass('_hide');

		setTimeout(() => {
			this.applySplitting(to);
			$newInf.removeClass('_hide').addClass('_show');
			$oldInf.removeClass('_hide');
		}, 1500);

		this.anim.to($oldInf, {y: -150, opacity: 0, display: 'none', duration: 1, ease: 'cubic.inOut'}, 0.3);
		this.anim.fromTo($newInf, {y: 200, opacity: 0, display: 'none'}, {
			y: 0,
			opacity: 1,
			display: 'flex',
			duration: 1.5,
			ease: 'expo.out'
		}, 0.6);
		this.anim.to($oldElt, {y: -height, duration: 1, rotationZ: 0.01, display: 'none', ease: 'cubic.inOut'}, 0.33);
		this.anim.fromTo($newElt, {y: height}, {
			y: 0,
			duration: 1,
			rotationZ: 0.01,
			display: 'block',
			ease: 'cubic.inOut'
		}, 0.3);

		this.actual = to;
	},

	toggleShadow(el, nb) {
		const shadow = $(`${el}[data-nb="${nb}"]`).data('shadow');
		$('.__back_black').toggleClass('_show', shadow === 'Y');
	},

	applySplitting(nb) {
		const target = document.querySelector(`h2[data-nb="${nb}"]`);
		if (target) {
			Splitting({target, by: 'lines'});
			document.querySelectorAll('h2.words.lines .word').forEach((item) => {
				const lineIndex = item.style.getPropertyValue('--line-index');
				item.classList.add(`line-${lineIndex}`);
			});
		}
	},

	lightbox() {

		// Une page peut contenir plusieurs galeries (galerie principale + une
		// par hébergement sur les packages) : il faut une instance lightGallery
		// par conteneur, pas uniquement sur le premier trouvé sur la page.
		const galleryContainers = document.querySelectorAll("._grid_medias");
		if (!galleryContainers.length) return;

		// 1) évite multi-bind du bouton "Show medias"
		$(document).off("click.galerieShowMedias");

		// 2) détruit proprement les instances précédentes
		if (this.lg) {
			this.lg.forEach((instance) => instance.destroy(true));
		}
		this.lg = [];

		// 3) selector EXCLUANT les placeholders cachés
		const selector = ".__img:not(._hidden)";

		galleryContainers.forEach((galleryContainer) => {
			// sécurité: si aucun item, on stop (sinon LG init “à vide”)
			if (!galleryContainer.querySelector(selector)) return;

			const instance = lightGallery(galleryContainer, {
				selector,
				speed: 800,
				hideBarsDelay: window.matchMedia('(max-width: 600px)').matches ? 0 : 6000,
				download: false,
				counter: true,
				showCloseIcon: true,
				controls: true,
				mobileSettings: {
					controls: true,
					showCloseIcon: true,
					download: false,
				},
				closable: true,            // laisse true pendant debug
				plugins: [lgVideo],
				licenseKey: "0000-0000-000-0000", // dev
				nextHtml: '<svg class="_ic_lucide"><use xlink:href="#__ic_chevron_lucide"/></svg>',
				prevHtml: '<svg class="_ic_lucide"><use xlink:href="#__ic_chevron_lucide"/></svg>',
			});

			instance.__container = galleryContainer;
			this.lg.push(instance);
		});

		// 4) ouvrir via API - on retrouve l'instance de la bonne galerie via
		// l'id du conteneur (data-id sur le bouton "Show medias")
		$(document).on("click.galerieShowMedias", "._show_medias", (e) => {
			e.preventDefault();
			const targetId = $(e.currentTarget).data("id");
			const instance = this.lg.find((inst) => inst.__container.id === targetId);
			instance?.openGallery(0);
		});
	}
};

export default galerie;
